import {
  MINIMUM_NON_CREDIT_CARD_NAME_LENGTH,
  STRIPE_PAYMENT_METHODS,
} from 'components/PaymentMethodSelector/PaymentMethodSelector.constants';
import {
  composeValidators,
  minLengthValidator,
  requiredValidator,
  requiredIfExistsValidator,
  validateFields,
} from 'validators';

/**
 * Creates aesthetic form validators dependent on the pased in payment method
 * @param {Object} data
 * @param {String} param.activePaymentMethod Stripe's payment method type
 */
export const Validator = (data, { activePaymentMethod = STRIPE_PAYMENT_METHODS.CARD }) => {
  switch (activePaymentMethod) {
    case STRIPE_PAYMENT_METHODS.CARD:
      return data.isReactivation
        ? composeValidators(validateFields(requiredIfExistsValidator, ['ccName']))(data)
        : composeValidators(validateFields(requiredValidator, ['ccName']))(data);
    case STRIPE_PAYMENT_METHODS.IDEAL:
      return composeValidators(
        validateFields(requiredValidator, ['idealName']),
        validateFields(minLengthValidator.bind(null, MINIMUM_NON_CREDIT_CARD_NAME_LENGTH), ['idealName'])
      )(data);
    case STRIPE_PAYMENT_METHODS.SOFORT:
      return composeValidators(
        validateFields(requiredValidator, ['sofortName']),
        validateFields(minLengthValidator.bind(null, MINIMUM_NON_CREDIT_CARD_NAME_LENGTH), ['sofortName'])
      )(data);
    case STRIPE_PAYMENT_METHODS.SEPA:
      return composeValidators(
        validateFields(requiredValidator, ['ibanName']),
        validateFields(minLengthValidator.bind(null, MINIMUM_NON_CREDIT_CARD_NAME_LENGTH), ['ibanName'])
      )(data);
    default:
      return {};
  }
};
